module.exports = __webpack_public_path__ + "media/images/my-code-94cb7f4c8041d05863cc982c04d36074.png";